import Vue from 'vue'
import Vuex from 'vuex'
import { router } from '@/router';
import { apolloClient } from '@/apollo'
import gql from "graphql-tag";

import moment from 'moment'
import axios from 'axios'

import { PublicClientApplication } from '@azure/msal-browser';

Vue.use(Vuex)

function parseJwt(token) {
  let jsonPayload = "{\"iat\":0,\"exp\":0}"
  if (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    jsonPayload = decodeURIComponent(Buffer.from(base64, "base64").toString("ascii").split("").map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }
  console.log(jsonPayload)
  return JSON.parse(jsonPayload);
};

export const store = new Vuex.Store({
  state: {
    tokenid: 'token',
    sidebarShow: 'responsive',
    sidebarMinimize: false,
    asideShow: false,
    darkMode: true,
    invoicing: false,
    selection: [],
    notifications: [],
    bookingforms: [],
    documents: [],
    queued: [],
    chold: [],
    ghold: [],
    xhold: [],
    zhold: [],
    pnrs: [],
    tokens: [],
    clients: [],
    palette: [
      {
        backgroundColor: "rgba(32, 168, 216, 0.1)",
        borderColor: "#20a8d8",
        pointHoverBackgroundColor: "#20a8d8",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(248, 108, 107, 0.1)",
        borderColor: "#f86c6b",
        pointHoverBackgroundColor: "#f86c6b",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(77, 189, 116, 0.1)",
        borderColor: "#4dbd74",
        pointHoverBackgroundColor: "#4dbd74",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(66,62,200, 0.1)",
        borderColor: "#423ec8",
        pointHoverBackgroundColor: "#423ec8",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(107,60,202, 0.1)",
        borderColor: "#6b3cca",
        pointHoverBackgroundColor: "#6b3cca",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(159,58,204, 0.1)",
        borderColor: "#9f3acc",
        pointHoverBackgroundColor: "#9f3acc",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(207,55,115, 0.1)",
        borderColor: "#cf3773",
        pointHoverBackgroundColor: "#cf3773",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(203,59,69, 0.1)",
        borderColor: "#cb3b45",
        pointHoverBackgroundColor: "#cb3b45",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(207,83,55, 0.1)",
        borderColor: "#cf5337",
        pointHoverBackgroundColor: "#cf5337",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(201,156,61, 0.1)",
        borderColor: "#c99c3d",
        pointHoverBackgroundColor: "#c99c3d",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(173,205,57, 0.1)",
        borderColor: "#adcd39",
        pointHoverBackgroundColor: "#adcd39",
        borderWidth: 2
      },

      {
        backgroundColor: "rgba(27,128,217, 0.1)",
        borderColor: "#1b80d9",
        pointHoverBackgroundColor: "#1b80d9",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(9,38,235, 0.1)",
        borderColor: "#0926eb",
        pointHoverBackgroundColor: "#0926eb",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(69,9,235, 0.1)",
        borderColor: "#4509eb",
        pointHoverBackgroundColor: "#4509eb",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(127,5,239, 0.1)",
        borderColor: "#7f05ef",
        pointHoverBackgroundColor: "#7f05ef",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(242,2,239, 0.1)",
        borderColor: "#f202ef",
        pointHoverBackgroundColor: "#f202ef",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(230,14,95, 0.1)",
        borderColor: "#e60e5f",
        pointHoverBackgroundColor: "#e60e5f",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(227,31,17, 0.1)",
        borderColor: "#e31f11",
        pointHoverBackgroundColor: "#e31f11",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(233,104,11, 0.1)",
        borderColor: "#e9680b",
        pointHoverBackgroundColor: "#e9680b",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(233,193,11, 0.1)",
        borderColor: "#e9c10b",
        pointHoverBackgroundColor: "#e9c10b",
        borderWidth: 2
      }
    ],
    showClipboard: false,
    clipboard: null,
    user: null,
    busy: false,
    token: null,
    error: null,
    window: {
      width: 0,
      height: 0,
    },
    msalConfig: {
      auth: {
        clientId: process.env.VUE_APP_MSAL_CLIENTID,
        authority: process.env.VUE_APP_MSAL_AUTHORITY,
        redirectUri: process.env.VUE_APP_MSAL_REDIRECTURI
      },
      cache: {
        cacheLocation: 'localStorage',
      },
    },
  },
  mutations: {
    toggleSidebarDesktop(state) {
      const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
      state.sidebarShow = sidebarOpened ? false : 'responsive'
    },
    toggleSidebarMobile(state) {
      const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
      state.sidebarShow = sidebarClosed ? true : 'responsive'
    },
    set(state, [variable, value]) {
      if (variable == "error") {
        value.message = value.message.split("GraphQL error: Error: ").join("")
        state["busy"] = false
      }
      state[variable] = value
    },
    put(state, [variable, value]) {
      console.log(variable, value)
      state[variable].push(value)
    },
    async toggle(state, variable) {
      state[variable] = !state[variable]
      if (variable == "darkMode") {
        try {
          let result = await apolloClient.mutate({
            mutation: gql`
                mutation updateUser($id:String!, $theme:String) {
                  updateUser(id: $id, theme: $theme ) {
                    id
                    theme                                   
                  }
                }
            `,
            variables: {
              id: state.user.id,
              theme: state[variable] ? 'dark' : 'light'
            }
          })

        } catch (error) {
          // commit('set', ['error', error])
        }
      }
    },
    setUser: (state, payload) => {
      state.user = payload;
    },
    setLoading: (state, payload) => {
      state.loading = payload;
    },
    clearError: state => (state.error = null),
    setAccessToken(state, token) {
      state.accessToken = token;
    }
  },
  actions: {
    clearerror: async ({ commit }, payload) => {
      commit("clearError")
    },
    currentUser: async ({ commit, dispatch }) => {

      let jwtPayload = null

      let url = null
      try {
        url = new URL(window.location)
      } catch (error) {
        console.log(error)
      }

      if (url.searchParams.has("token")) {
        jwtPayload = parseJwt(url.searchParams.get("token"))
      } else {
        jwtPayload = parseJwt(localStorage.getItem(store.state.tokenid))
      }
      if (jwtPayload.exp < Date.now() / 1000) {
        commit("setUser", null)
        localStorage.setItem(store.state.tokenid, "")
        router.push('/signin')
      }
      commit('set', ['busy', true])

      let variables = {
        id: jwtPayload.id
      }

      try {
        let users = await apolloClient.query({
          query: gql`
            query setup_users($id: String) {
                setup_users (id: $id) {
                    id
                    name
                    email
                    initials
                    title
                    firstname
                    lastname
                    department
                    avatarb64
                    theme
                    slac
                    yourref
                    company
                    companylogob64
                    dateformat
                    timeformat
                    perpage
                    beats
                    idle
                    forcelogout
                    created_at
                    updated_at
                    permissions
                    favourites
                    rolename
                  }
                }
            `,
          variables
        })

        commit('set', ['busy', false])
        if (users.data.setup_users) {

          commit('set', ['user', users.data.setup_users[0]])

          if (users.data.setup_users[0].theme.toLowerCase() == "dark") {
            commit('set', ['darkMode', true])
          } else {
            commit('set', ['darkMode', false])
          }

          // dispatch("notifications")

        }
      } catch (error) {
        commit('set', ['error', error])
      }
    },
    signinMS: async ({ commit }, payload) => {

      let query = await apolloClient.query({
        query: gql`
          query setup_systemsettings($name: String) {
            setup_systemsettings(name: $name) {
              data
            }
          }
        `,
        variables: { name: "msal" }
      });
      let data = query.data.setup_systemsettings[0].data
      data = Buffer.from(data, "base64").toString("ascii")
      let settings = JSON.parse(data)
      let key = process.env.VUE_APP_GRAPHQL_HTTP ? process.env.VUE_APP_GRAPHQL_HTTP : "http://localhost:8080"
      let setting = settings.find(o => o.key == key)

      if (setting) {
        localStorage.setItem(store.state.tokenid, "")

        let msalInstance = new PublicClientApplication(
          setting.msalConfig,
        );

        // MSAL.js v2 exposes several account APIs, logic to determine which account to use is the responsibility of the developer
        const account = msalInstance.getAllAccounts()[0];

        const accessTokenRequest = {
          scopes: ["user.read"],
          account: account,
        };

        let response = null
        try {
          response = await msalInstance.acquireTokenSilent(accessTokenRequest)
        } catch (error) {
          response = await msalInstance.acquireTokenPopup(accessTokenRequest)
        }
        if (response) {

          let variables = {
            access: key,
            accessToken: response.accessToken
          }
          commit('set', ['busy', true])
          try {
            let result = await apolloClient.mutate({
              mutation: gql`
                mutation($access:String, $accessToken: String!) {
                    signinToken(access:$access, accessToken: $accessToken ) {
                        token
                    }
                }
            `,
              variables
            })
            localStorage.setItem(store.state.tokenid, result.data.signinToken.token)
            router.go();
          } catch (error) {
            commit('set', ['error', error])
          }
          commit('set', ['busy', false])
        }
      }
    },
    signoutMS: async ({ commit }, payload) => {

      let query = await apolloClient.query({
        query: gql`
          query setup_systemsettings($name: String) {
            setup_systemsettings(name: $name) {
              data
            }
          }
        `,
        variables: { name: "msal" }
      });

      let data = query.data.setup_systemsettings[0].data
      data = Buffer.from(data, "base64").toString("ascii")
      let settings = JSON.parse(data)
      let key = process.env.VUE_APP_GRAPHQL_HTTP ? process.env.VUE_APP_GRAPHQL_HTTP : "http://localhost:8080"
      let setting = settings.find(o => o.key == key)
      if (setting) {
        let msalInstance = new PublicClientApplication(
          setting.msalConfig,
        );
        await msalInstance.logoutPopup({})
      }

    },
    signinUser: async ({ commit }, payload) => {
      commit('set', ['busy', true])
      try {
        let result = await apolloClient.mutate({
          mutation: gql`
              mutation($email: String!, $password: String!, $track: String) {
                  signinUser(email: $email, password: $password, track: $track ) {
                      token
                  }
              }
          `,
          variables: payload
        })
        localStorage.setItem(store.state.tokenid, result.data.signinUser.token)
        // router.go();
      } catch (error) {
        commit('set', ['error', error])
      }
      commit('set', ['busy', false])
    },
    signoutUser: ({ commit, dispatch }) => {
      commit("setUser", null)
      localStorage.setItem(store.state.tokenid, "")
      router.push('/signin')
    },
    invoicing: async ({ commit }) => {

      let result = await apolloClient.query({
        query: gql`
          query setup_systemsettings($name: String) {
            setup_systemsettings(name: $name) {
              data
            }
          }
        `,
        variables: { name: "invoicing_enabled" }
      });
      if (result.data.setup_systemsettings.length > 0) {
        let enabled = result.data.setup_systemsettings[0].data
        commit('set', ['invoicing', enabled == 'yes' ? true : false])
      } else {
        commit('set', ['invoicing', false])
      }
    },
    notifications: async ({ commit }) => {
      try {
        let result = await apolloClient.query({
          query: gql`
              query notifications($to: String) {
                  notifications(to: $to, isnew: true) {
                      id
                      description
                      created_at                     
                      data
                      type
                  }
              }
          `,
          variables: { to: store.state.user.email }
        })
        if (result.data.notifications) {
          commit('set', ['notifications', result.data.notifications])
        } else {
          commit('set', ['notifications', []])
        }
      } catch (error) {
        console.log(error)
        commit('set', ['error', error])
      }
    },
    bookingforms: async ({ commit }) => {
      let variables = {
        mssql: true,
        status: store.state.user.permissions.includes('bookingforms.admin') ? 'submitted' : 'unsubmitted',
        agent: store.state.user.permissions.includes('bookingforms.admin') ? null : store.state.user.initials,
        issued_at: ['2023-10-01', moment().format('YYYY-MM-DD')]
      }
      try {
        let result = await apolloClient.query({
          query: gql`
              query bookingforms($mssql: Boolean, $status: String, $agent: String, $issued_at: [String] ) {
                bookingforms(mssql: $mssql, status: $status, agent: $agent, issued_at: $issued_at ) {
                      id
                  }
              }
          `,
          variables
        })
        if (result.data.bookingforms) {
          commit('set', ['bookingforms', result.data.bookingforms])
        } else {
          commit('set', ['bookingforms', []])
        }
      } catch (error) {
        console.log(error)
        commit('set', ['error', error])
      }
    },
    documents: async ({ commit }) => {

      try {
        let result = await apolloClient.query({
          query: gql`
              query documents($slac: String) {
                documents(slac: $slac, isnew: "true", isarchive: "false") {
                      id
                  }
              }
          `,
          variables: { slac: null }
        })
        // store.state.user.slac
        if (result.data.documents) {
          commit('set', ['documents', result.data.documents])
        } else {
          commit('set', ['documents', []])
        }
      } catch (error) {
        commit('set', ['error', error])
      }
    },
    queued: async ({ commit }) => {

      let variables = {
        created_at: [moment().startOf('year').format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
        isinvoiced: false
      }
      console.log(variables)
      try {
        let result = await apolloClient.query({
          query: gql`
              query queue($created_at:[String], $isinvoiced:Boolean $status: String, ) {
                queue(created_at: $created_at, isinvoiced:$isinvoiced, status: $status) {
                      id
                  }
              }
          `,
          variables
        })
        if (result.data.queue) {
          commit('set', ['queued', result.data.queue])
        } else {
          commit('set', ['queued', []])
        }
      } catch (error) {
        commit('set', ['error', error])
      }
    },

    chold: async ({ commit }) => {

      let variables = {
        source: "chold",
        status: "ready",
      }
      try {
        let result = await apolloClient.query({
          query: gql`
            query ihold_counts($source: String,  $status: String) {
                ihold_counts(source: $source, status: $status) {
                      rows
                  }
              }
          `,
          variables
        })
        if (result.data.ihold_counts) {
          let size = 0
          if (result.data.ihold_counts.length > 0) {
            size = result.data.ihold_counts[0].rows
          }
          let foo = [...Array(size).keys()].map(foo => foo + 1)

          commit('set', ['chold', foo])
        } else {
          commit('set', ['chold', []])
        }
      } catch (error) {
        commit('set', ['error', error])
      }
    },
    ghold: async ({ commit }) => {

      let variables = {
        source: "ghold",
        status: "ready",
      }
      try {
        let result = await apolloClient.query({
          query: gql`
              query ihold_counts($source: String,  $status: String) {
                ihold_counts(source: $source, status: $status) {
                      rows
                  }
              }
          `,
          variables
        })
        if (result.data.ihold_counts) {
          let size = 0
          if (result.data.ihold_counts.length > 0) {
            size = result.data.ihold_counts[0].rows
          }
          let foo = [...Array(size).keys()].map(foo => foo + 1)

          commit('set', ['ghold', foo])
        } else {
          commit('set', ['ghold', []])
        }
      } catch (error) {
        commit('set', ['error', error])
      }
    },
    xhold: async ({ commit }) => {

      let variables = {
        source: "xhold",
        status: "ready",
      }
      console.log(variables)
      try {
        let result = await apolloClient.query({
          query: gql`
              query ihold_counts($source: String,  $status: String) {
                ihold_counts(source: $source, status: $status) {
                      rows
                  }
              }
          `,
          variables
        })
        if (result.data.ihold_counts) {
          let size = 0
          if (result.data.ihold_counts.length > 0) {
            size = result.data.ihold_counts[0].rows
          }
          let foo = [...Array(size).keys()].map(foo => foo + 1)
          console.log('ghold foo=', foo, result.data.ihold_counts)

          commit('set', ['xhold', foo])
        } else {
          commit('set', ['xhold', []])
        }
      } catch (error) {
        commit('set', ['error', error])
      }
    },
    zhold: async ({ commit }) => {

      let variables = {
        type: 'byclient',
      }
      console.log(variables)
      try {
        let result = await apolloClient.query({
          query: gql`
              query tickets_zholdcounts($type: String) {
                tickets_zholdcounts(type:$type) {
                  count
                  }
              }
          `,
          variables
        })
        if (result.data.tickets_zholdcounts) {
          let size = 0

          for (var i = 0; i < result.data.tickets_zholdcounts.length; ++i) {
            size += parseInt(result.data.tickets_zholdcounts[i].count)
          }

          let foo = [...Array(size).keys()].map(foo => foo + 1)

          commit('set', ['zhold', foo])
        } else {
          commit('set', ['zhold', []])
        }
      } catch (error) {
        commit('set', ['error', error])
      }
    },
    pnrs: async ({ commit }) => {

      try {
        let result = await apolloClient.query({
          query: gql`
              query pnrs($isunticketed: Boolean) {
                pnrs(isunticketed: $isunticketed) {
                      id
                  }
              }
          `,
          variables: { isunticketed: true }
        })
        if (result.data.pnrs) {
          commit('set', ['pnrs', result.data.pnrs])
        } else {
          commit('set', ['pnrs', []])
        }
      } catch (error) {
        commit('set', ['error', error])
      }
    },
    // notification: async ({ commit }, payload) => {

    //   payload.vue.$bvToast.toast(payload.message,
    //     {
    //       autoHideDelay: 5000,
    //       variant: payload.variant,
    //       title: payload.subject,
    //       solid: true
    //     });
    //   delete payload.vue

    //   commit('put', ['notifications', { ...payload, date: new Date() }])
    // },
    // events: async ({ commit }) => {

    //   let variables = {
    //     event: null
    //   }
    //   try {
    //     let result = await apolloClient.query({
    //       query: gql`
    //         query events_ddl($event: String) {
    //           events_ddl(event: $event) {
    //             events {
    //               id
    //               label
    //               children {
    //                 id
    //                 label
    //                 children {
    //                   id
    //                   label
    //                 }
    //               }
    //             }
    //           }
    //         }
    //       `,
    //       variables
    //     })
    //     let data = result.data.events_ddl.events
    //     for (var j = 0; j < data.length; ++j) {
    //       if (!data[j].children) {
    //         delete data[j].children
    //       } else {
    //          for (var k = 0; k < data[j].children.length; ++k) {
    //            if (!data[j].children[k].children) {
    //              delete data[j].children[k].children
    //            }
    //          }
    //       }
    //     }
    //     commit('set', ['events', data])
    //   } catch (error) {
    //     commit('set', ['error', error])
    //   }
    // },
    // clients: async ({ commit }) => {

    //   try {
    //     let result = await apolloClient.query({
    //       query: gql`
    //           query clients($email: String) {
    //               clients(email: $email) {
    //                   id


    //               }
    //           }
    //       `,
    //       variables: { email: store.state.user.email }
    //     })
    //     commit('set', ['clients', result.data.clients])
    //   } catch (error) {
    //     commit('set', ['error', error])
    //   }
    // },
    // tokens: async ({ commit }) => {

    //   try {
    //     let result = await apolloClient.query({
    //       query: gql`
    //           query tokens($email: String) {
    //             tokens(email: $email) {
    //                   id


    //               }
    //           }
    //       `,
    //       variables: { email: store.state.user.email }
    //     })
    //     commit('set', ['tokens', result.data.tokens])
    //   } catch (error) {
    //     commit('set', ['error', error])
    //   }
    // },
    heartstart: async ({ commit, dispatch }) => {
      console.log('heartstart')
      if (!store.state.heart) {
        console.log('no heart', store.state.heart)
        store.state.heart = setInterval(() => {
          dispatch("heartbeat")
        }, store.state.user.beats)
        console.log('heart id:', store.state.heart)
      }
      dispatch("heartbeat")
    },
    heartstop: async ({ commit, dispatch }) => {
      console.log('heartstop')
      if (store.state.heart) {
        clearTimeout(store.state.heart);
        console.log('heart id: ', store.state.heart)
        store.state.heart = null;
      }
    },
    heartbeat: async ({ commit, dispatch }) => {
      //commit("setBeating", true);
      console.log('heartbeat', new Date())

      let jwtPayload = parseJwt(localStorage.getItem(store.state.tokenid))
      if (jwtPayload.exp < Date.now() / 1000) {
        commit("setUser", null)
        localStorage.setItem(store.state.tokenid, "")
        router.push('/signin')
      }

      if (store.state.user) {

        dispatch("documents")
        dispatch("pnrs")

        dispatch("bookingforms")
        dispatch("chold")
        dispatch("ghold")
        dispatch("xhold")
        dispatch("zhold")
        dispatch("queued")

        dispatch("notifications")
        dispatch("invoicing")
      }

      store.state.beating = !store.state.beating

      //commit("setBeating", false);
    },
    heartswitch: async ({ commit, dispatch }) => {
      console.log('heartswitch')
      if (store.state.heart) {
        dispatch('heartstop')
      } else {
        dispatch('heartstart')
      }
    },
    resize: async ({ commit }, payload) => {
      commit('set', ['window', payload])
    }
  },
  getters: {
    notifications: state => state.notifications,
    documents: state => state.documents,
    bookingforms: state => state.bookingforms,
    chold: state => state.chold,
    ghold: state => state.ghold,
    xhold: state => state.xhold,
    zhold: state => state.zhold,
    events: state => state.events,
    clients: state => state.clients,
    tokens: state => state.tokens,
    palette: state => state.palette,
    user: state => state.user,
    heart: state => state.heart,
    heartbeat: state => state.heartbeat,
    beating: state => state.beating,
    busy: state => state.busy,
    error: state => state.error,
    window: state => state.window,
  }
});
